<template>
  <div>
    <el-form-item label="颜色设置">
      <el-color-picker v-model="activeData.npsBackgroundColor" size="mini" />
    </el-form-item>
    <el-form-item label="辅助文字">
      <el-switch v-model="activeData['show-auxiliary-text']" />
    </el-form-item>
    <template v-if="activeData['show-auxiliary-text']">
      <el-form-item label="左边文字">
        <el-input v-model="activeData.textLeft" maxlength="10" />
      </el-form-item>
      <el-form-item label="中间文字">
        <el-input v-model="activeData.textCenter" maxlength="10" />
      </el-form-item>
      <el-form-item label="右边文字">
        <el-input v-model="activeData.textRight" maxlength="10" />
      </el-form-item>
    </template>
    <el-form-item label="NPS标签设置">
      <div @click="openDialog" style="font-size: 14px" class="flex-row align-center">
        <el-button type="text">设置标签</el-button>
        <div class="border_l"></div>
        <span class="setting">
          <i class="el-icon-setting" />
          <span class="drawing-item__check" v-if="activeData.npsTagList.length > 0">
            <i class="el-icon-check"></i>
          </span>
        </span>
      </div>
    </el-form-item>

    <el-dialog class="setting-nps-tag" :visible.sync="rulesVisible" width="40%">
      <div slot="title" class="dialog-title">
        <h2>设置NPS标签</h2>
        <span class="title_tips">用于识别不同评分对应的标签</span>
      </div>
      <el-form :model="formData" :rules="rules" ref="scoreForm" label-position="left" class="nps-tag-form">
        <div v-for="(item, index) in formData.tagList" :key="index" class="nps-tag-row">
          <el-form-item>
            <el-input :disabled="true" v-model="item.name"></el-input>
          </el-form-item>
          <el-form-item> <span style="margin: 0 18px 0 5px">：</span> </el-form-item>
          <el-form-item :prop="'tagList.' + index + '.beginScore'" required>
            <el-select v-model="item.beginScore" placeholder="开始分">
              <el-option
                :disabled="isDisabled('start', item, n - 1)"
                v-for="n in 11"
                :key="n - 1"
                :label="n - 1"
                :value="n - 1"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <span style="margin: 0 32px">~</span>
          </el-form-item>

          <el-form-item :prop="'tagList.' + index + '.endScore'" required>
            <el-select v-model="item.endScore" placeholder="结束分">
              <el-option
                :disabled="isDisabled('end', item, n - 1)"
                v-for="n in 11"
                :key="n - 1"
                :label="n - 1"
                :value="n - 1"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <span style="margin-left: 10px">分</span>
          </el-form-item>
        </div>
      </el-form>
      <div class="tips title_tips">
        提示：请设置连续的区间，否则未分组的数据NPS标签为空，如设置了重复区间导致一条数据符合多个分组，则优先分配给排序较前的分组。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rulesVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddRules">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'ConfigItemNps',
  props: ['activeData'],
  data() {
    return {
      rulesVisible: false,
      formData: {
        tagList: _.cloneDeep(this.activeData.npsTagList)
      },
      rules: {}
    }
  },
  mounted() {
    this.generateRules()
  },
  methods: {
    confirmAddRules() {
      this.activeData.npsTagList = this.formData.tagList
      this.rulesVisible = false
    },
    openDialog() {
      this.rulesVisible = true
      this.formData.tagList = _.cloneDeep(this.activeData.npsTagList)
      this.generateRules()
    },
    generateRules() {
      const rules = {}
      this.formData.tagList.forEach((_, index) => {
        rules[`tagList.${index}.beginScore`] = [{ required: true, message: '请选择分数！', trigger: 'change' }]
        rules[`tagList.${index}.endScore`] = [{ required: true, message: '请选择分数！', trigger: 'change' }]
      })
      this.rules = rules
    },
    isDisabled(type, tagItem, optionVal) {
      const { beginScore, endScore } = tagItem
      if ((type === 'start' && endScore == null) || (type === 'end' && beginScore == null)) return false
      return type === 'start' ? optionVal > endScore : optionVal < beginScore
    }
  }
}
</script>

<style lang="scss" scoped>
// 设置按钮
.setting {
  font-size: 14px;
  display: inline-block;
  position: relative;
}
.border_l {
  height: 14px;
  border-left: 1px solid #ccc;
  margin: 0 5px;
}
.drawing-item__check {
  position: absolute;
  font-size: 5px;
  background: #5dc976;
  color: #fff;
  width: 7px;
  height: 7px;
  line-height: 7px;
  border-radius: 50%;
  left: 10px;
  bottom: 9px;
  text-align: center;
}
.setting-nps-tag {
  .nps-tag-row {
    display: flex;
    padding-right: 50px;
  }
  .tips {
    margin-top: 40px;
    padding-top: 10px;
    border-top: 1px solid #ccc;
  }
}
</style>
